var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"arrow-button-mock",attrs:{"color":_vm.state ? _vm.activeColor : _vm.inactiveColor,"elevation":"0","small":_vm.small,"rounded":""},on:{"click":function($event){_vm.state = !_vm.state}}},[_c('lynus-icon',{attrs:{"name":_vm.icon,"color":"white","size":_vm.iconSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }